import React from "react";

function Help() {
  return (
    <div className="Help__content">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto
      exercitationem corporis a deserunt dolorum provident optio nam earum.
      Libero hic odit mollitia reprehenderit ea provident nam, maxime fuga ad,
      corrupti numquam! Ullam nulla ratione, aliquam totam odio cupiditate
      tenetur perspiciatis et deserunt similique beatae, sunt, doloribus
      dolores. Vitae voluptate expedita consequatur esse ullam repellat qui
      totam? Voluptas possimus voluptatem repellendus error magnam, sint
      reiciendis rerum, totam harum accusantium id ut at beatae fuga
      reprehenderit ex quae inventore libero neque odit quisquam quo nobis!
      Eaque laudantium illum obcaecati maiores nobis reiciendis autem molestiae
      totam, eum, unde, sunt quo voluptates corrupti tempora? Cum nulla unde
      provident magnam error rem hic quidem delectus exercitationem? Asperiores
      inventore voluptas repellendus magnam, rerum omnis modi! Impedit
      molestiae, quas porro hic, temporibus commodi autem culpa tempora officiis
      odit sequi tenetur eveniet eaque. Tempora nostrum ut maxime a. Aspernatur
      accusantium sed voluptates, dolore non, doloremque eveniet, quis laborum
      est iusto praesentium perferendis animi optio facere aliquid laboriosam
      pariatur quaerat consequatur hic at recusandae debitis! Harum aliquam nam,
      perspiciatis explicabo amet excepturi nihil architecto, libero ducimus
      sint molestias unde officiis laudantium accusamus, sed dolores recusandae
      pariatur! Laboriosam, repudiandae voluptatem, sint veniam, assumenda
      reiciendis suscipit vero ut officia ducimus maiores facilis consequuntur
      ad exercitationem hic commodi. Doloribus perferendis quam natus sequi
      veniam nisi necessitatibus ducimus cupiditate quibusdam corrupti cum,
      atque dicta id sint amet quas ipsam fugit, iste saepe vero harum minus.
      Nisi delectus, unde odit sed vero animi ut! Deserunt repellendus, dolor id
      delectus commodi, accusantium at ratione quae consequuntur ex facilis
      numquam explicabo aperiam odio. Soluta dolorum dolores dolor! Totam nisi
      non tempore reprehenderit enim adipisci quae, consequuntur maxime illum
      quisquam distinctio quas necessitatibus neque quam? Exercitationem iure
      magni rem facilis vitae totam fugit eius aspernatur sed recusandae,
      expedita nobis nisi consequuntur enim reprehenderit vero eaque ad
      architecto dolores maiores? Numquam, facere alias itaque impedit rerum
      error molestiae soluta adipisci reprehenderit provident magni consectetur
      ducimus repudiandae esse dicta iure doloremque! Possimus porro deleniti
      debitis nam quasi? Reprehenderit accusantium iure distinctio commodi,
      dolore possimus adipisci suscipit nesciunt error similique corrupti quo
      accusamus eum optio libero aut doloremque repellendus facere ullam sint
      neque quae tempore nemo. Ipsam placeat quibusdam omnis maxime corporis
      saepe consequatur magni! Sint inventore, voluptas repellat, laboriosam
      consequatur vel earum minima facere sed voluptate quae dolorem, eligendi
      non repellendus nostrum commodi? Cupiditate ab iusto cumque corrupti
      consectetur placeat laborum fugit quibusdam quae repellendus vitae
      laudantium deleniti, inventore earum perspiciatis tempore libero nisi,
      magnam, error nulla autem. Molestiae commodi, libero praesentium nisi eum
      excepturi eligendi placeat a temporibus cupiditate reprehenderit eaque eos
      perferendis, autem delectus eveniet veritatis ab beatae reiciendis
      accusamus. Maxime, harum sapiente unde itaque blanditiis laboriosam
      tenetur! Odit impedit voluptates quasi quo tempora dignissimos quae
      commodi? Molestias ex minima esse assumenda delectus doloribus eum facilis
      hic ratione nulla laboriosam nobis totam provident, optio impedit ea
      maxime exercitationem reiciendis asperiores reprehenderit porro
      consequatur incidunt! Blanditiis necessitatibus, accusamus placeat, atque
      repellendus repudiandae neque voluptatibus illo amet impedit et earum
      fugit, nobis ipsam porro libero ex! Veniam, repellat cumque!
    </div>
  );
}

export default Help;
